import clone from "clone";
import { newInvoice, initialListView, getDataAccountInvoice } from "../../pages/Invoice/config";
import actions from "./actions";

const initState = {
  invoices: [],
  editableInvoice: {},
  // Status and id of the invoice AS IT WAS LOADED. The edit page locks on these, never on
  // editableInvoice.orderStatus, which the status dropdown changes before Save.
  persistedOrderStatus: null,
  persistedInvoiceId: null,
  isLoadingInvoice: true,
  generationInProgress: false,
  updatingItemsBookingInvoice: false,
  isSubmitted: false,
  errorMessage: null,
  successMessage: null,
  resetMessage: false,
  listView: {...initialListView},
  // Pagination state
  pagination: {
    currentPage: 1,
    pageSize: 50,
    hasMore: false,
    // Cache cursors for each page: { 1: { lastDoc, firstDoc }, 2: { lastDoc, firstDoc }, ... }
    pageCursors: {}
  }
};

export default function cardReducer(
  state = initState,
  { type, payload, ...action }
) {
  switch (type) {
    case actions.GET_INVOICES: {
      return {
        ...state,
        listView: { ...state.listView, filter: payload.filter },
        editableInvoice: clone(getDataAccountInvoice(newInvoice)),
      };
    }
    case actions.GET_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: action.invoices,
        isLoadingInvoice: false,
        isSubmitted: false
      };
    }
    // Paginated invoices loading
    case actions.GET_INVOICES_PAGINATED: {
      // If page is 1, reset cursors (new filter/search)
      const shouldResetCursors = payload.page === 1;
      return {
        ...state,
        isLoadingInvoice: true,
        listView: { ...state.listView, filter: payload.filter },
        editableInvoice: clone(getDataAccountInvoice(newInvoice)),
        pagination: {
          ...state.pagination,
          currentPage: payload.page || 1,
          pageSize: payload.pageSize || 50,
          pageCursors: shouldResetCursors ? {} : state.pagination.pageCursors
        }
      };
    }
    case actions.GET_INVOICES_PAGINATED_SUCCESS: {
      // Save cursor for current page
      const currentPage = action.currentPage || state.pagination.currentPage;
      const newPageCursors = {
        ...state.pagination.pageCursors,
        [currentPage]: {
          lastDoc: action.lastDoc,
          firstDoc: action.firstDoc
        }
      };
      return {
        ...state,
        invoices: action.invoices,
        isLoadingInvoice: false,
        isSubmitted: false,
        pagination: {
          ...state.pagination,
          currentPage: currentPage,
          hasMore: action.hasMore,
          pageCursors: newPageCursors
        }
      };
    }
    case actions.UPDATE_INVOICE: {
      return {
        ...state,
        editableInvoice: clone(payload.invoice),
      };
    }
    case actions.UPDATE_LIST_VIEW: {
      return {
        ...state,
        listView: clone(payload.listView)
      }
    }
    case actions.UPDATE_INVOICE_SUCCESS: {
      return {
        ...state,
        isSubmitted: true
      }
    }
    case actions.UPDATE_INVOICE_ITEM_BOOKING: {
      return {
        ...state,
        updatingItemsBookingInvoice: true
      }
    }
    case actions.UPDATE_INVOICE_ITEM_BOOKING_SUCCESS: {
      return {
        ...state,
        updatingItemsBookingInvoice: false
      }
    }
    case actions.EDIT_INVOICE:
      return {
        ...state,
        editableInvoice: clone(action.invoice),
      };
    case actions.UPDATE_INVOICES_BULK:
      return {
        ...state,
        generationInProgress: true
      };
    case actions.UPDATE_INVOICES_BULK_SUCCESS:
      return {
        ...state,
        generationInProgress: false
      };
    case actions.GET_INVOICE:
      return {
        ...state,
      };
    case actions.GET_INVOICE_SUCCESS:
      return {
        ...state,
        isLoadingInvoice: false,
        editableInvoice: payload.data,
        persistedOrderStatus: payload.data && payload.data.orderStatus !== undefined ? payload.data.orderStatus : null,
        persistedInvoiceId: payload.data && payload.data.id !== undefined ? payload.data.id : null,
      };
    case actions.GET_iNVOICE_ERROR:
      return {
        ...state,
        editableInvoice: clone(getDataAccountInvoice(newInvoice)),
        isLoadingInvoice: false,
      };
    case actions.UPDATE_DATA_USER_INVOICE:
      return {
        ...state,
      };
    case actions.UPDATE_INVOICE_ERROR:
      return {
        ...state,
        isSubmitted: false,
        errorMessage: payload && payload.message ? payload.message : 'The invoice could not be saved. Please try again.',
        successMessage: null,
        resetMessage: !state.resetMessage,
        // The saga read the stored document and found it final: lock the page that is still open on it
        persistedOrderStatus: payload && payload.storedOrderStatus !== undefined ? payload.storedOrderStatus : state.persistedOrderStatus,
      };
    case actions.DELETE_INVOICE_ERROR:
      return {
        ...state,
        errorMessage: payload.message,
        successMessage: null,
        resetMessage: !state.resetMessage,
      };
    case actions.DELETE_INVOICE_SUCCESS:
      return {
        ...state,
        successMessage: payload.message,
        errorMessage: null,
        resetMessage: !state.resetMessage,
      };
    // Sin esto la consulta fallida dejaba la lista ANTERIOR en pantalla: parecia
    // que la busqueda habia funcionado cuando en realidad no se filtro nada.
    case actions.GET_INVOICES_PAGINATED_ERROR:
      return {
        ...state,
        invoices: [],
        isLoadingInvoice: false,
        isSubmitted: false,
        errorMessage: payload && payload.message ? payload.message : 'Could not load the invoices. Please try again.',
        successMessage: null,
        resetMessage: !state.resetMessage,
        pagination: {
          ...state.pagination,
          hasMore: false,
        },
      };
    // The e-mail queue says an invoice is queued / sent / failed: patch the rows on screen WITHOUT reloading the
    // list (a reload would reset the page and the user's selection). Same state object when nothing changes, so
    // the 3-second polling does not re-render the table.
    case actions.PATCH_INVOICES_EMAIL_STATE: {
      const patches = (payload && payload.patches) || {};
      let changed = false;
      const invoices = state.invoices.map((invoice) => {
        const patch = patches[invoice.key];
        if (!patch) return invoice;
        const differs = Object.keys(patch).some((k) => invoice[k] !== patch[k] && !(patch[k] && typeof patch[k] === 'object' && JSON.stringify(invoice[k]) === JSON.stringify(patch[k])));
        if (!differs) return invoice;
        changed = true;
        return { ...invoice, ...patch };
      });
      return changed ? { ...state, invoices } : state;
    }
    case actions.CLEAR_INVOICE_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        successMessage: null,
      };
    default:
      return state;
  }
}
